module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-input-calendar/~/babel-runtime/core-js/object/define-property.js
// module id = 1247
// module chunks = 3